import * as React from "react"

const SvgDashboardFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.4598 15.5C10.877 15.9167 11.4026 16.1125 12.0367 16.0875C12.6708 16.0625 13.1296 15.8333 13.4133 15.4L17.6432 9.075C17.7934 8.84167 17.7725 8.62917 17.5806 8.4375C17.3887 8.24583 17.176 8.225 16.9424 8.375L10.61 12.6C10.1762 12.9 9.93841 13.3542 9.89669 13.9625C9.85498 14.5708 10.0427 15.0833 10.4598 15.5ZM5.10361 20C4.73652 20 4.39862 19.9208 4.08993 19.7625C3.78124 19.6042 3.53512 19.3667 3.35157 19.05C2.91773 18.2667 2.58401 17.4542 2.35041 16.6125C2.1168 15.7708 2 14.9 2 14C2 12.6167 2.26281 11.3167 2.78842 10.1C3.31403 8.88333 4.02736 7.825 4.92841 6.925C5.82946 6.025 6.88902 5.3125 8.10711 4.7875C9.32519 4.2625 10.6267 4 12.0117 4C13.3799 4 14.6647 4.25833 15.8661 4.775C17.0675 5.29167 18.1188 5.99583 19.0198 6.8875C19.9209 7.77917 20.6384 8.82083 21.1723 10.0125C21.7063 11.2042 21.9816 12.4833 21.9983 13.85C22.015 14.7667 21.9107 15.6625 21.6854 16.5375C21.4601 17.4125 21.1139 18.25 20.6467 19.05C20.4632 19.3667 20.217 19.6042 19.9083 19.7625C19.5996 19.9208 19.2618 20 18.8947 20H5.10361Z" />
  </svg>
)
export default SvgDashboardFilled
